import { HttpService, HttpServiceResponse } from '../shared'
import {
  AMLUsersServerData,
  AMLAction,
  UnslJournalAttributes,
  ZoneJournalAttributes,
  ExternalJournalAttributes,
  RiskOperJournalAttributes,
  RiskLevelsJournalAttributes,
} from './aml.types'

export class AMLProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return this.baseUrl
  }

  public users(
    action: AMLAction,
    startDate: string,
    endDate: string,
    search: string,
    RiskLevelID: number | string,
  ): Promise<HttpServiceResponse<AMLUsersServerData>> {
    return this.http.post(`${this.url}/aml_journal_view_api.php?action=${action}`, {
      StartDate: startDate,
      EndDate: endDate,
      SearchString: search,
      RiskLevelID,
    })
  }

  public addToJournal(
    action: AMLAction,
    attributes:
      | UnslJournalAttributes
      | ZoneJournalAttributes
      | ExternalJournalAttributes
      | RiskOperJournalAttributes
      | RiskLevelsJournalAttributes,
  ): Promise<HttpServiceResponse<unknown>> {
    return this.http.post(`${this.url}/aml_journal_oper_api.php?action=${action}`, { ...attributes })
  }
}
